import { useTranslation } from 'react-i18next';
import type { IArticlePriceGraduatedPriceStepDtoData } from '~/dtos/ProdegaApiWebshop-api-typings-generated';
import type { BghArticleDetail } from '~/common/types/bghArticleDetail';

interface PriceStepsProps {
  article: BghArticleDetail;
}

export function PriceSteps({ article }: Readonly<PriceStepsProps>) {
  const { t } = useTranslation();

  if (!article.graduatedPriceSteps) {
    return null;
  }

  return (
    <div>
      {article.graduatedPriceSteps.map((step: IArticlePriceGraduatedPriceStepDtoData, i: number) => {
        const amount = Number(step.quantity.toFixed(0));
        const unit = article.unitText;
        let sellUnitInfo;

        if (article.sellAmount > 1 && amount % article.sellAmount === 0) {
          const sellAmount = amount / article.sellAmount;
          const sellUnit = article.sellUnit;
          sellUnitInfo = '(' + sellAmount + ' ' + sellUnit + ') ';
        }

        return (
          <div key={step.quantity} className={'flex gap-2'} data-testid={`price-steps-${article.articleNumber}-${i}`}>
            <div>
              {t('ab')} {amount} {unit} {sellUnitInfo ? <span>{sellUnitInfo}</span> : null}
            </div>
            <div>
              {t('CHF')} {step.price.toFixed(2)} / {unit}
            </div>
          </div>
        );
      })}
    </div>
  );
}
